import { Box } from "@chakra-ui/react";
import { Control, UseFormSetValue } from "react-hook-form";
import ButtonAnexarArquivos from "components/Button/ButtonAnexarArquivos";
import Anexos from "components/Anexos";
import useUploadAnexo from "core/features/arquivo/useUploadAnexo";
import { useState } from "react";
import { OrcamentoCotacaoItemForm } from "features/orcamento/typings";

interface AnexarArquivosProps {
  control: Control<OrcamentoCotacaoItemForm, any>;
  form: OrcamentoCotacaoItemForm;
  setValue: UseFormSetValue<OrcamentoCotacaoItemForm>;
  pushArquivoRemovido?: (id: string) => any;
}
function AnexarArquivos({
  control,
  form,
  setValue,
  pushArquivoRemovido,
}: AnexarArquivosProps) {
  const [disableButtonAnexar, setDisabledButtonAnexar] = useState(false);

  return (
    <Box>
      <Box w="200px">
        <ButtonAnexarArquivos
          accept="image/*, application/pdf, video/*, .csv, .xlsx"
          maxFileSizeMb={200}
          currentFilesLength={form?.anexos?.length || 0}
          variant='outline'
          disabled={disableButtonAnexar}
          onAnexar={(files) => {
            if (files) {
              const currentAnexos = form?.anexos;

              setValue(
                "anexos",
                currentAnexos ? [...currentAnexos, ...files] : files
              );
            }
          }}
        />
      </Box>

      <Box gap="16px" mt="auto" h="fit-content" py={2} flexDir="column">
        {form?.anexos?.length ? (
          <Anexos
          numColumns={6}
            onStartUploadMutation={() => setDisabledButtonAnexar(true)}
            onFinishUploadMutation={() => setDisabledButtonAnexar(false)}
            autoUploadMutation={useUploadAnexo}
            trackRemove={(id) => {
              if (id) {
                pushArquivoRemovido?.(id);
              }
            }}
            setValue={(files) => {
              setValue(
                "anexos",
                files?.map((file) =>
                  Object.assign(file, {
                    nome:
                      file instanceof File || Reflect.has(file, "name")
                        ? file.name
                        : file.nome!,
                  })
                ) || []
              );
            }}
            anexos={
              form.anexos?.map((file) =>
                file instanceof File ? file : { ...file, name: file.nome }
              ) || undefined
            }
          />
        ) : null}
      </Box>
    </Box>
  );
}

export default AnexarArquivos;
